import { useState, useEffect } from "react";
import { adminImpersonateUser, getSingleUser } from "../api";
import {
  Title,
  Grid,
  Text,
  Code,
  Button,
  Badge,
  Group,
  Accordion,
  Paper,
  TextInput,
  Center,
  Loader,
  CopyButton,
  Tooltip,
  ActionIcon,
  rem,
} from "@mantine/core";
import { IconCheck, IconCopy } from "@tabler/icons-react";
import UserSessions from "../UserSessions";
import UserLogins from "../UserLogins";

export default function AdminUserDetails({ params }) {
  const [user, setUser] = useState(null);
  useEffect(() => {
    getSingleUser(params.userId).then((data) => setUser(data));
  }, [params.userId]);

  const [impersonateData, setImpersonateData] = useState({ loginUrl: "" });

  if (!user) {
    return (
      <Center>
        <Loader />
      </Center>
    );
  }

  const userName =
    user.firstName && user.lastName
      ? `${user.lastName}, ${user.firstName} <${user.loginName}>`
      : user.loginName;

  return (
    <Grid p="md">
      <Grid.Col span={12}>
        <Title order={1}>{userName}</Title>
        <Group>
          <Badge
            color={user.role == "TenantUser" ? "gray" : "grape"}
            radius="xs"
          >
            {user.role}
          </Badge>
          <Text c="dimmed">{user.created}</Text>
          <Text c="dimmed">{user.emailAddress}</Text>
        </Group>
      </Grid.Col>

      <Grid.Col span={6}>
        <Paper>
          <Title order={2}>Logins</Title>

          <UserLogins user={user} />
          <Group>
            <Button
              variant="default"
              size="sm"
              onClick={() =>
                adminImpersonateUser({ userId: user.id }).then((data) => {
                  setImpersonateData(data);
                })
              }
            >
              Impersonate
            </Button>

            <TextInput
              style={{ flex: 1 }}
              value={impersonateData?.loginUrl}
              readOnly
              rightSection={
                <CopyButton value={impersonateData?.loginUrl} timeout={2000}>
                  {({ copied, copy }) => (
                    <Tooltip
                      label={copied ? "Copied" : "Copy"}
                      withArrow
                      position="right"
                    >
                      <ActionIcon
                        color={copied ? "teal" : "gray"}
                        variant="subtle"
                        onClick={copy}
                      >
                        {copied ? (
                          <IconCheck style={{ width: rem(16) }} />
                        ) : (
                          <IconCopy style={{ width: rem(16) }} />
                        )}
                      </ActionIcon>
                    </Tooltip>
                  )}
                </CopyButton>
              }
            />
          </Group>
        </Paper>
      </Grid.Col>

      <Grid.Col span={6}>
        <Title order={2}>Sessions</Title>
        <UserSessions user={user} />
      </Grid.Col>

      <Grid.Col span={12}>
        <Accordion>
          <Accordion.Item key="json" value="json">
            <Accordion.Control>JSON</Accordion.Control>
            <Accordion.Panel>
              {" "}
              <Code block>{JSON.stringify(user, null, 2)}</Code>
            </Accordion.Panel>
          </Accordion.Item>
        </Accordion>
      </Grid.Col>

      <Grid.Col span={6}></Grid.Col>
    </Grid>
  );
}
